import {
  faCircleExclamation,
  faCirclePlus,
  faFileArrowUp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, TextField, Typography } from "@mui/material";
import ImageUploaderModal from "common/ImageUploaderModal";
import ReusableEditor from "common/ReusableCKEditor";
import Toggle from "common/Toggle";
import config from "config";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router";
import {
  createBlogAPICall,
  getAllBlogCategoriesList,
  getAllBlogTagsAPICall,
} from "services/apiService";
const BlogCreate: React.FC = () => {
  const [blogForm, setBlogForm] = useState({
    title: "",
    blog_category_id: "",
    blog_tag_id: "",
    description: "",
    image_path: "",
    message: "",
    is_active: 0,
  });
  const navigate = useNavigate();
  const [blogCategories, setblogCategories] = useState([]);
  const [blogTagsCategories, setblogTagsCategories] = useState([]);
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const [errors, setErrors] = useState({
    title: "",
    blog_category_id: "",
    blog_tag_id: "",
    description: "",
    message: "",
  });
  const AppUrl = config.REACT_APP_IMAGE_URL;
  useEffect(() => {
    getAllBlogCategories();
    getAllBlogTags();
  }, []);
  const getAllBlogCategories = async () => {
    try {
      const response = await getAllBlogCategoriesList();
      if (response.status_code === 200) {
        setblogCategories(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const getAllBlogTags = async () => {
    try {
      const response = await getAllBlogTagsAPICall();
      if (response.status_code === 200) {
        setblogTagsCategories(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const validateForm = () => {
    const newErrors: any = {};
    if (!blogForm.title.trim()) newErrors.title = "Title is required.";
    if (!blogForm.blog_category_id)
      newErrors.blog_category_id = "Blog category is required.";
    if (!blogForm.blog_tag_id) newErrors.blog_tag_id = "Blog tag is required.";
    if (!blogForm.description.trim())
      newErrors.description = "Description is required.";
    if (!blogForm.message.trim()) newErrors.message = "Message is required.";
    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };
  const handleTextFieldChange = (e) => {
    const { id, value } = e.target;
    setBlogForm((prevData) => ({
      ...prevData,
      [id]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [id]: "",
    }));
  };
  const handleToggleChange = (checked: number, field: string) => {
    setBlogForm((prevData) => ({
      ...prevData,
      [field]: checked ? 1 : 0,
    }));
  };
  const handleImageSelected = (image: string) => {
    setBlogForm((prevState) => ({
      ...prevState,
      image_path: image,
    }));
    setModalOpen(false);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      if (!blogForm.image_path) {
        toast.error("Please select an  image for the blog.");
        return;
      }
      try {
        const payload = {
          ...blogForm,
          image_path: blogForm.image_path.toString(),
          blog_category_id: Number(blogForm.blog_category_id),
          blog_tag_id: Number(blogForm.blog_tag_id),
        };
        const response = await createBlogAPICall(payload);
        if (response.status_code === 200) {
          toast.success("Blog created successfully !");
          navigate("/blog-list");
        } else {
          toast.error("Blog creation failed");
        }
      } catch (error) {
        console.log("error", error);
      }
    }
  };
  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);
  return (
    <>
      <form onSubmit={handleSubmit}>
        <Box sx={{ px: 4, py: 2, mx: "auto" }}>
          <Box display="flex" alignItems="center" mb={3} gap={2}>
            <Typography sx={{ width: 200 }} variant="subtitle1">
              Blog Title
            </Typography>
            <TextField
              fullWidth
              id="title"
              name="title"
              placeholder="Type Here"
              value={blogForm.title}
              onChange={handleTextFieldChange}
              variant="filled"
              error={!!errors.title}
              helperText={errors.title || " "}
            />
          </Box>
          <Box display="flex" alignItems="flex-start" mb={3} gap={2}>
            <Typography sx={{ width: 200, pt: 1 }} variant="subtitle1">
              Blog Category
            </Typography>
            <Box sx={{ flex: 1 }}>
              <select
                id="blog_category_id"
                name="blog_category_id"
                className="form-select"
                value={blogForm.blog_category_id}
                onChange={handleTextFieldChange}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "4px",
                  borderColor: errors.blog_category_id ? "red" : "#ccc",
                }}
              >
                <option value="">Select blog category</option>
                {blogCategories?.map((blogCategory) => (
                  <option key={blogCategory.id} value={blogCategory.id}>
                    {blogCategory.name.toUpperCase()}
                  </option>
                ))}
              </select>
              {errors.blog_category_id && (
                <Typography variant="caption" color="error">
                  {errors.blog_category_id}
                </Typography>
              )}
            </Box>
          </Box>
          <Box display="flex" alignItems="flex-start" mb={3} gap={2}>
            <Typography sx={{ width: 200, pt: 1 }} variant="subtitle1">
              Blog Tag
            </Typography>
            <Box sx={{ flex: 1 }}>
              <select
                id="blog_tag_id"
                name="blog_tag_id"
                className="form-select"
                value={blogForm.blog_tag_id}
                onChange={handleTextFieldChange}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "4px",
                  borderColor: errors.blog_tag_id ? "red" : "#ccc",
                }}
              >
                <option value="">Select blog tag</option>
                {blogTagsCategories?.map((blogTag) => (
                  <option key={blogTag.id} value={blogTag.id}>
                    {blogTag.name.toUpperCase()}
                  </option>
                ))}
              </select>
              {errors.blog_tag_id && (
                <Typography variant="caption" color="error">
                  {errors.blog_tag_id}
                </Typography>
              )}
            </Box>
          </Box>
          <Box display="flex" alignItems="flex-start" mb={3} gap={2}>
            <Typography sx={{ width: 200, pt: 1 }} variant="subtitle1">
              Description
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={4}
              id="description"
              name="description"
              placeholder="Type description here"
              variant="filled"
              value={blogForm.description}
              onChange={handleTextFieldChange}
              error={!!errors.description}
              helperText={errors.description || " "}
            />
          </Box>
          <Box display="flex" alignItems="flex-start" mb={3} gap={2}>
            <Typography sx={{ width: 200, pt: 1 }} variant="subtitle1">
              Message
            </Typography>
            <Box sx={{ flex: 1 }}>
              <ReusableEditor
                value={blogForm.message}
                onChange={(value) => {
                  setBlogForm((prev) => ({ ...prev, message: value }));
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    message: "",
                  }));
                }}
              />
              {errors.message && (
                <Typography variant="caption" color="error">
                  {errors.message}
                </Typography>
              )}
            </Box>
          </Box>
          <Box display="flex" alignItems="flex-start" mb={3} gap={2}>
            <Typography sx={{ width: 200, pt: 1 }} variant="subtitle1">
              Image
            </Typography>
            <Box sx={{ flex: 1 }}>
              <Box
                sx={{
                  border: "1px dashed #ccc",
                  p: 2,
                  textAlign: "center",
                  backgroundColor: "#F9F9F9",
                }}
              >
                {blogForm.image_path ? (
                  <img
                    src={`${AppUrl}${blogForm.image_path}`}
                    alt="Selected"
                    style={{
                      width: "200px",
                      height: "150px",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <Typography color="warning.main">
                    <FontAwesomeIcon icon={faCircleExclamation} /> No image
                    selected
                  </Typography>
                )}
                <Box mt={1}>
                  <Button
                    onClick={handleOpenModal}
                    size="small"
                    variant="contained"
                    startIcon={<FontAwesomeIcon icon={faFileArrowUp} />}
                  >
                    Upload Image
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box display="flex" alignItems="center" mb={3} gap={2}>
            <Typography sx={{ width: 200 }} variant="subtitle1">
              Status
            </Typography>
            <Toggle
              checked={blogForm.is_active === 1}
              onChange={(checked) => handleToggleChange(checked, "is_active")}
            />
          </Box>
          <Box textAlign="center" mt={5}>
            <Button type="submit" variant="contained" size="large">
              <FontAwesomeIcon icon={faCirclePlus} /> &nbsp; Create Blog
            </Button>
          </Box>
        </Box>
      </form>
      <ImageUploaderModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onImageSelect={handleImageSelected}
        allowMultiple={false}
      />
    </>
  );
};
export default BlogCreate;